export const ROUTES = {
  ROOT: '/',
  CB: '/cb',
  DEVICES: '/devices',
  AT_SPECIFICATION: '/at-specifications',
  SENSOR_SPECIFICATION: '/sensor-specifications',
};
